import { AstraPractitionerChip, AstraTooltip, EntityChipVariant, SizeOptions } from '~/astra'

export type PractitionerChipProps = {
    shortName: string
    fullName?: string
    prefix?: string
    size?: SizeOptions
    variant?: EntityChipVariant
}

export const PractitionerChipWithTooltip = ({ shortName, fullName, prefix, size = 'small', variant = 'ghost' }: PractitionerChipProps) => (
    <AstraTooltip tooltipContent={fullName ?? shortName}>
        <AstraPractitionerChip shortName={shortName} fullName={fullName} prefix={prefix} size={size} title={null} variant={variant} />
    </AstraTooltip>
)
